import { CustomProps, ParcelConfigObject } from 'single-spa';

export const getModuleConfig = async (moduleName: string, scope: string): Promise<ParcelConfigObject<CustomProps>> => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  await __webpack_init_sharing__('default');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const container = window[scope]; // or get the container somewhere else
  // Initialize the container, it may provide shared modules
  // eslint-disable-next-line no-undef
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  await container.init(__webpack_share_scopes__.default);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const factory = await window[scope].get(`./${moduleName}`);

  return factory();
};
